import { Category } from '@/domain/models/content/category'
import PathConstants from '../path-contants'

const getCategoriesPaths = (): PathConstants.RoutesProps => {
  return Category.getAvailables().reduce((acc, category) => {
    return {
      ...acc,
      [`CATEGORY_${category.name.toUpperCase()}`]: {
        value: `/category/${category.name.toLocaleLowerCase()}`,
        name: category.name.toLocaleLowerCase(),
        title: category.title
      }
    }
  }, {})
}

export default getCategoriesPaths
